export const currencyQueryKeys = {
  id: 'id',
  name: 'currency_name',
  createdAt: 'created_at',
};
